/**
 * Pure component for displaying the result of submitting their confirmed details.
 * Can show success or error depending on result of request.
 */
import React, { FunctionComponent } from 'react';
import NewUserButton from './common/new-user-button';

interface IInfoBoxProps {
    error: boolean; // Was there an error when submitting the confirmed details
    handleClick: () => void; // Action to call on info box being dismissed
}

interface IInfoBoxFields {
    bodyText: string; // Text to appear in the body of the info-box
    buttonText: string; // Text to appear on the button
    iconClasses: string; // The icon that should show
}

const infoBoxFields = (error: boolean): IInfoBoxFields => ({
    bodyText: error
        ? 'Something has gone wrong, please try again'
        : 'Good job, your details were correct and you can now use them to log into Sparx',
    buttonText: error ? 'Finish' : 'Log in to Sparx',
    iconClasses: error ? 'fa-times-circle error' : 'fa-check-circle valid',
});

const InfoBoxView: FunctionComponent<IInfoBoxProps> = ({
    error,
    handleClick,
}: IInfoBoxProps): JSX.Element => {
    const { bodyText, buttonText, iconClasses }: IInfoBoxFields = infoBoxFields(error);

    return (
        <div className="new-user-success-page">
            <div className="new-user-view-content">
                <div className="new-user-view-box new-user-info-box">
                    <i className={`fa ${iconClasses} user-user-dot xl`} />

                    <p>{bodyText}</p>

                    <div className="new-user-view-form-button-group">
                        <NewUserButton type="submit" value={buttonText} handleClick={handleClick} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoBoxView;
